var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgIaIcon2(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 22,
    height: 23,
    viewBox: "0 0 22 23",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M8.8 13.7H13.2V11.5H8.8V13.7ZM8.8 10.4H17.6V8.2H8.8V10.4ZM8.8 7.1H17.6V4.9H8.8V7.1ZM6.6 18.1C5.995 18.1 5.47727 17.8848 5.0468 17.4543C4.6156 17.0231 4.4 16.505 4.4 15.9V2.7C4.4 2.095 4.6156 1.5769 5.0468 1.1457C5.47727 0.715233 5.995 0.5 6.6 0.5H19.8C20.405 0.5 20.9231 0.715233 21.3543 1.1457C21.7848 1.5769 22 2.095 22 2.7V15.9C22 16.505 21.7848 17.0231 21.3543 17.4543C20.9231 17.8848 20.405 18.1 19.8 18.1H6.6ZM6.6 15.9H19.8V2.7H6.6V15.9ZM2.2 22.5C1.595 22.5 1.07727 22.2848 0.6468 21.8543C0.2156 21.4231 0 20.905 0 20.3V4.9H2.2V20.3H17.6V22.5H2.2Z",
    fill: "#00BC92"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIaIcon2);
export default __webpack_public_path__ + "static/media/iaIcon_2.78385980dc79fa82a075c56ddedf1913.svg";
export { ForwardRef as ReactComponent };